import StatusCard from 'components/Header/StatusCard';
import Flex from 'components/ui/Flex';
import { BatchReturnStatusType } from 'returnCenter-api';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { getBatchStatsTranslations } from 'utils/helpers';
import { BatchReturnStatusStatistic } from 'types/batchReturn';

export const BATCH_RETURN_STATUSES: BatchReturnStatusType[] = [
    BatchReturnStatusType.Open,
    BatchReturnStatusType.Closed,
    BatchReturnStatusType.Sent,
    BatchReturnStatusType.Incoming,
    BatchReturnStatusType.PartiallyReceived,
    BatchReturnStatusType.Received,
    BatchReturnStatusType.PartiallyProcessed,
    BatchReturnStatusType.Completed,
];

type BatchReturnStatusCardsProps = {
    statistics: BatchReturnStatusStatistic[] | null;
    loadingCards: Partial<Record<string, boolean>>;
    selectedStatus: BatchReturnStatusType | null;
    handleClick: (statusType: BatchReturnStatusType, value?: number) => void;
};

const BatchReturnStatusCards = ({
    statistics,
    loadingCards,
    selectedStatus,
    handleClick,
}: BatchReturnStatusCardsProps) => {
    const { t } = useTranslation();

    return (
        <Wrapper gap="1rem" align="center" justify="center" className="batch-return-status-cards w-100">
            {BATCH_RETURN_STATUSES.map((status) => {
                const item = statistics?.find((stat) => stat.status === status);
                const value = item?.value ?? 0;
                const isChanging = !!loadingCards[String(status)];

                return (
                    <StatusCard
                        key={status}
                        statistics={{ status, value }}
                        label={getBatchStatsTranslations(t, status)}
                        onClick={() => handleClick(status, value)}
                        isChanging={isChanging}
                        isSelected={selectedStatus === status}
                        noResults={value === 0}
                    />
                );
            })}
        </Wrapper>
    );
};

export default BatchReturnStatusCards;

const Wrapper = styled(Flex)`
    flex-wrap: wrap;

    @media (max-width: 832px) {
        justify-content: center;
    }
`;
